<template>
  <div
    class="action-button"
    :class="buttonClass"
  >
    <component
      :is="getComponent(button)"
      class="action-button-inner"
      :class="buttonInnerClass"
      role="menuitem"
      type="button"
      placement="bottom"
      :title="$t(button.label(funcArg))"
      target="_blank"
      :tabindex="0"
      :disabled="button.interactive ? !button.interactive(funcArg) : false"
      :href="getComponent(button) == 'a' ? button.link?.(funcArg) || remoteInteractionLink : undefined"
      @click="doActionWrap(button, outerClose)"
    >
      <FALayers>
        <FAIcon
          class="fa-scale-110"
          :icon="button.icon(funcArg)"
          :spin="!extra && getComponent(button) == 'button' && button.animated?.() && animationState"
          :style="{ '--fa-animation-duration': '750ms' }"
          fixed-width
        />
        <template v-if="!buttonClass.disabled && (!button.interactive || button?.interactive(funcArg)) && button.toggleable?.(funcArg) && button.active">
          <FAIcon
            v-if="button.active(funcArg) && button.activeIndicator?.() !== null"
            class="active-marker"
            transform="shrink-6 up-9 left-12"
            :icon="button.activeIndicator?.(funcArg) || 'check'"
          />
          <FAIcon
            v-if="!button.active(funcArg)"
            class="focus-marker"
            transform="shrink-6 up-9 left-12"
            :icon="button.openIndicator?.(funcArg) || 'plus'"
          />
          <FAIcon
            v-else
            class="focus-marker"
            transform="shrink-6 up-9 left-12"
            :icon="button.closeIndicator?.(funcArg) || 'minus'"
          />
        </template>
      </FALayers>
      <span
        v-if="extra"
        class="action-label"
      >
        {{ $t(button.label(funcArg)) }}
      </span>
      <FAIcon
        v-if="button.dropdown?.()"
        class="chevron-icon"
        :icon="extra ? 'chevron-right' : 'chevron-down'"
        fixed-width
      />
      <span
        v-if="chip && counterShown"
        class="action-counter"
      >{{ shortCount(button.counter(funcArg)) }}</span>
    </component>
    <!-- Participant counters load on hover, including cold timeline posts. -->
    <UserListPopover
      v-if="!chip && counterShown && peopleAvailable"
      :user-ids="people"
      :load="button.loadPeople ? () => button.loadPeople(funcArg) : undefined"
      :has-more="button.hasMorePeople?.(funcArg)"
      :load-more="button.loadMorePeople ? () => button.loadMorePeople(funcArg) : undefined"
      :needs-load="!people"
      class="action-counter-popover"
      trigger-tag="span"
    >
      <component
        :is="button.counterLink ? 'router-link' : 'span'"
        class="action-counter"
        :to="button.counterLink?.(funcArg)"
        :title="button.counter(funcArg)"
        @click="button.counterLink && outerClose?.()"
      >
        {{ shortCount(button.counter(funcArg)) }}
      </component>
    </UserListPopover>
    <component
      :is="button.counterLink ? 'router-link' : 'span'"
      v-else-if="!chip && counterShown"
      class="action-counter"
      :to="button.counterLink?.(funcArg)"
      :title="button.counter(funcArg)"
      @click="button.counterLink && outerClose?.()"
    >
      {{ shortCount(button.counter(funcArg)) }}
    </component>
    <span
      v-if="!extra && button.name === 'bookmark'"
      class="separator"
    />
    <Popover
      v-if="button.name === 'bookmark'"
      class="chevron-popover"
      :trigger="extra ? 'hover' : 'click'"
      :placement="extra ? 'right' : 'bottom'"
      :offset="extra ? { x: 10 } : { y: 10 }"
      :trigger-attrs="{ class: 'extra-button' }"
    >
      <template #trigger>
        <FAIcon
          class="chevron-icon"
          :icon="extra ? 'chevron-right' : 'chevron-down'"
          fixed-width
        />
      </template>
      <template #content="{close}">
        <StatusBookmarkFolderMenu
          v-if="button.name === 'bookmark'"
          :status="status"
          @close="() => { close(); outerClose?.() }"
        />
      </template>
    </Popover>

    <!-- made on the first click: every post has one, few are opened -->
    <EmojiPicker
      v-if="button.name === 'emoji' && pickerWanted"
      ref="picker"
      :enable-sticker-picker="false"
      :hide-custom-emoji="hideCustomEmoji"
      :notice="reactionNotice"
      quick
      class="emoji-picker-panel"
      @emoji="addReaction"
      @show="onShowEmojiPicker"
      @close="onHideEmojiPicker"
    />
  </div>
</template>

<script src="./action_button.js" />

<style lang="scss" src="./action_button.scss" />
